import { render, staticRenderFns } from "./InputAccountType.vue?vue&type=template&id=2197412e&scoped=true&"
import script from "./InputAccountType.vue?vue&type=script&lang=js&"
export * from "./InputAccountType.vue?vue&type=script&lang=js&"
import style0 from "./InputAccountType.vue?vue&type=style&index=0&id=2197412e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197412e",
  null
  
)

export default component.exports